import { Link } from 'react-router-dom'
import { ArrowRight, FolderOpen, Palette, Trash2 } from 'lucide-react'
import { ETICHETE_FAZA, ETICHETE_TIP } from '@b4l/shared'
import { PanouLateral } from '../../ui/PanouLateral'
import { Pastila } from '../../ui/Pastila'
import { PatratTip, TON_FAZA, candRelativ, type ActivitateCuFaza } from './activitate'
import { RezumatActivitate } from './RezumatActivitate'

/**
 * Rezumatul unei activitati, in panoul din dreapta — clic pe un rand din lista (Madalin,
 * 15.10.2026). Raspunde la „despre ce e vorba si ce cere atentie" fara sa deschizi pagina.
 */
export function PanouActivitate({
  a,
  numeResponsabil,
  onInchide,
  onSterge,
}: {
  a: ActivitateCuFaza | null
  numeResponsabil: string | null
  onInchide: () => void
  /** Doar cand se poate sterge: activitate creata de mana, fara actiuni pe teren. */
  onSterge?: () => void
}) {
  if (!a) return null
  return (
    <PanouLateral
      deschis
      onInchide={onInchide}
      titlu={
        <span className="grid gap-0.5">
          <span className="font-mono text-[11.5px] font-normal text-b4l-text-dim">{a.cod}</span>
          {a.titlu}
        </span>
      }
      subtitlu={
        <>
          <Pastila ton={TON_FAZA[a.faza]}>{ETICHETE_FAZA[a.faza]}</Pastila>
          <span className="inline-flex items-center gap-1.5 text-mic text-b4l-text-muted">
            <PatratTip tip={a.tip} eticheta={ETICHETE_TIP[a.tip]} mare={false} />
            {ETICHETE_TIP[a.tip]}
          </span>
          <span className="text-mic text-b4l-text-dim">{candRelativ(a)}</span>
        </>
      }
    >
      <RezumatActivitate a={a} numeResponsabil={numeResponsabil} />

      <div className="grid gap-2 border-t border-b4l-border pt-4">
        <Link
          to={`/marketing/evenimente/${a.id}`}
          className="inline-flex items-center justify-center gap-1.5 rounded-caseta bg-b4l-blue px-3 py-2 text-corp font-semibold text-white hover:opacity-90"
        >
          Deschide activitatea <ArrowRight size={15} />
        </Link>
        {(a.cereriDeAprobat ?? 0) > 0 && (
          <Link
            to={`/marketing/evenimente/${a.id}?fila=necesar`}
            className="inline-flex items-center justify-center rounded-caseta border border-b4l-border px-3 py-1.5 text-corp hover:border-b4l-blue"
          >
            Verifică cererea de marfă
          </Link>
        )}
        <div className="flex flex-wrap gap-2">
          <Link
            to={`/marketing/evenimente/${a.id}?fila=documente`}
            className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-caseta border border-b4l-border px-3 py-1.5 text-mic hover:border-b4l-blue"
          >
            <FolderOpen size={14} /> Documente & poze
          </Link>
          <Link
            to={`/marketing/evenimente/${a.id}?fila=grafica`}
            className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-caseta border border-b4l-border px-3 py-1.5 text-mic hover:border-b4l-blue"
          >
            <Palette size={14} /> Grafică
          </Link>
        </div>
        {onSterge && (
          <button
            type="button"
            onClick={onSterge}
            className="inline-flex items-center justify-center gap-1.5 self-start rounded-caseta px-2 py-1 text-mic text-b4l-text-muted hover:bg-b4l-red-light hover:text-b4l-red-dark"
          >
            <Trash2 size={14} /> Șterge activitatea
          </button>
        )}
      </div>
    </PanouLateral>
  )
}
